import { render, staticRenderFns } from "./TotalComplaints.vue?vue&type=template&id=0d6d84ca"
import script from "./TotalComplaints.vue?vue&type=script&lang=js"
export * from "./TotalComplaints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports